import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { BarcodeFormat, DecodeHintType } from "@zxing/library";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";

const codeFrom = (text) => {
  const m = text.match(/\/magazzino\/a\/([A-Za-z0-9-]+)/);
  return (m ? m[1] : text).trim();
};

export function ScanDialog({ open, onOpenChange }) {
  const videoRef = useRef(null);
  const nav = useNavigate();
  const [error, setError] = useState("");
  useEffect(() => {
    if (!open) { return undefined; }
    let controls;
    let done = false;
    setError("");
    const start = async () => {
      await new Promise((r) => setTimeout(r, 50));
      if (!videoRef.current) return;
      try {
        const hints = new Map([[DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE, BarcodeFormat.CODE_128]], [DecodeHintType.TRY_HARDER, true]]);
        controls = await new BrowserMultiFormatReader(hints).decodeFromConstraints({ video: { facingMode: "environment" } }, videoRef.current, async (res) => {
          if (!res || done) return;
          done = true;
          controls?.stop();
          const code = codeFrom(res.getText());
          try {
            const { data } = await api.get(`/wh/items/by-code/${encodeURIComponent(code)}`);
            onOpenChange(false);
            nav(`/magazzino/articoli/${data.id}`);
          } catch {
            toast.error(`Nessun articolo con codice ${code}`);
            onOpenChange(false);
          }
        });
        if (done) controls.stop();
      } catch {
        setError("Fotocamera non disponibile: consenti l'accesso alla fotocamera nel browser.");
      }
    };
    start();
    return () => { done = true; controls?.stop(); };
  }, [open, nav, onOpenChange]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[95dvh] overflow-y-auto" data-testid="scan-dialog">
        <DialogHeader><DialogTitle>Scansiona QR o codice a barre</DialogTitle><DialogDescription>Inquadra l'etichetta: la scheda dell'articolo si apre da sola.</DialogDescription></DialogHeader>
        {error ? <p className="text-sm text-red-600" data-testid="scan-error">{error}</p> : (
          <div className="relative rounded-xl overflow-hidden bg-black">
            <video ref={videoRef} autoPlay playsInline muted className="w-full max-h-[60dvh] object-cover" data-testid="scan-video" />
            <div className="pointer-events-none absolute inset-x-[12%] top-1/2 -translate-y-1/2 h-1/2 rounded-xl border-2 border-[var(--primary)]" />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
